/* eslint-disable no-console */
import { API_CONFIG } from '../config/api';

const CLOUD_RUN_BASE = 'https://zc-backend-552991655746.southamerica-west1.run.app';

function isCloudRunBase(baseUrl: string): boolean {
  if (!baseUrl) return false;
  try {
    return baseUrl.includes('run.app') || baseUrl.startsWith(CLOUD_RUN_BASE);
  } catch {
    return false;
  }
}

function isEnabled(): boolean {
  const fromEnv = String(process.env.REACT_APP_DEBUG_CLOUD_RUN || '').toLowerCase();
  const fromStorage = typeof window !== 'undefined' ? (window.localStorage.getItem('DEBUG_CLOUD_RUN') || '') : '';
  const baseUrl = API_CONFIG?.BASE_URL || '';
  return (
    isCloudRunBase(baseUrl) || fromEnv === '1' || fromEnv === 'true' || fromStorage === '1' || fromStorage === 'true'
  );
}

function now(): string {
  try {
    const d = new Date();
    return `${d.toISOString()}`;
  } catch {
    return '';
  }
}

export function log(tag: string, payload?: any) {
  if (!isEnabled()) return;
  const ts = now();
  try {
    if (payload === undefined) {
      console.log(`🟦 [CloudRun][${ts}] ${tag}`);
    } else {
      console.log(`🟦 [CloudRun][${ts}] ${tag}:`, payload);
    }
  } catch {
    // noop
  }
}

export function timeStart(label: string) {
  if (!isEnabled()) return;
  try { console.time(`🟦CloudRun ${label}`); } catch {}
}
export function timeEnd(label: string) {
  if (!isEnabled()) return;
  try { console.timeEnd(`🟦CloudRun ${label}`); } catch {}
}

export function summarizeResponse(resp: any) {
  if (!isEnabled()) return;
  try {
    const data = resp?.data ?? resp;
    const list = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : (Array.isArray(data?.parciales) ? data.parciales : null));
    log('Response summary', {
      success: data?.success,
      total: Array.isArray(list) ? list.length : undefined,
      sample: Array.isArray(list) ? list.slice(0, 2) : undefined,
    });
  } catch (e) {
    log('Response summary error', String(e));
  }
}
